<template>
  <div>
    <McTable
      class="template-delivery-table"
      ref="template-table"
      withCard
      searchable
      :disableSelect="isDisableSelect"
      :hasDelete="false"
      :hasSelectAll="false"
      :apiClient="apiClient"
      :fields="fields"
      :customHandlers="{
        handleClickRow: handleClickRow,
        isItemSelectDisabled: isItemSelectDisabled
      }"
      @handleSelectValue="$emit('update:selectedIds', $event)"
    >
      <template #cell(name)="{ item, value }">
        <div class="text-primary primary-field">
          <div @click="handleClickRow(item)">
            {{ value }}
          </div>

          <i v-if="item.is_error" class="icon-fill_alert-circle" />
        </div>
      </template>

      <template #cell(description)="{ value }">
        {{ value || '-' }}
      </template>

      <template #cell(created_on)="{ value }">
        <template>
          <div>{{ formatIndexDate(value).date }}</div>
          <div class="mc-datetime">{{ formatIndexDate(value).time }}</div>
        </template>
      </template>

      <template #cell(expected_pickup_on_interval)="{ value }">
        {{ formatDuration(value) }}
      </template>

      <template #cell(expected_delivered_on_interval)="{ value }">
        {{ formatDuration(value) }}
      </template>
    </McTable>
  </div>
</template>

<script>
import McTable from '@/components/McTable'

import * as TemplateDelivery from '@/services/rest-api/lib/delivery/template'
import moment from 'moment'

import fields from '../lib/fields/template-table-fields.js'
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  components: {
    McTable,
  },
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:selectedIds'],
  data() {
    return {
      fields,

      isDisableSelect: false,
    }
  },
  computed: {
    apiClient() {
      return {
        get: TemplateDelivery.get(),
      }
    },
  },
  watch: {
    selectedIds(newValue) {
      if (newValue.length === 0) {
        this.isDisableSelect = false

        return
      }

      this.isDisableSelect = true
    },
  },
  mounted() {
    if (this.selectedIds.length === 0) return

    this.$refs['template-table'].selectedIds = Object.fromEntries(
      this.selectedIds.map((v) => [v?.id, true])
    )
    this.$refs['template-table'].selectedIdsLength = this.selectedIds.length
  },
  methods: {
    formatIndexDate,

    handleClickRow(item) {
      this.$router.push({ name: 'Setting Template Delivery Order Detail', params: { id: item.id } })
    },

    formatDuration(value) {
      let duration = moment.duration(value)

      return `${duration.get('days')} Hari ${duration.get('hours')} Jam`
    },

    isItemSelectDisabled(item) {
      if (item.is_error) return true

      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.template-delivery-table {
  .primary-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    i {
      font-size: 16px;

      &:before {
        color: $red;
      }
    }
  }
}
</style>
